"use client";

import { c as _c } from "react/compiler-runtime";
import SecondaryButton from "@/components/utils/button/SecondaryButton";
import PrimaryButton from "@/components/utils/button/PrimaryButton";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { motion } from "framer-motion";
import { useCallback } from "react";
import { PreviewLeaderboardGalleryCase } from "./components/PreviewLeaderboardGalleryCase";
import { PreviewLeaderboardListCase } from "./components/PreviewLeaderboardListCase";
interface MemesSubmissionPreviewScreenProps {
  readonly previewDrop: ExtendedDrop;
  readonly onBackToEdit: () => void;
  readonly onSubmit: () => void;
  readonly isSubmitting: boolean;
  readonly submitLabel?: string | undefined;
}
export function MemesSubmissionPreviewScreen(t0) {
  const $ = _c(19);
  const {
    previewDrop,
    onBackToEdit,
    onSubmit,
    isSubmitting,
    submitLabel: t1
  } = t0;
  const submitLabel = t1 === undefined ? "Submit Artwork" : t1;
  const onDropClick = _temp;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      opacity: 0,
      y: 20
    };
    t3 = {
      opacity: 1,
      y: 0
    };
    t4 = {
      opacity: 0,
      y: -20
    };
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t2 = $[0];
    t3 = $[1];
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="tw-space-y-1"><h4 className="tw-mb-0 tw-text-base tw-font-semibold tw-text-iron-100">Submission Preview</h4><p className="tw-mb-0 tw-text-sm tw-text-iron-400">Read-only preview of how your submission may appear in different views.</p></div>;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== previewDrop) {
    t6 = <div className="tw-flex-1 tw-space-y-10 tw-overflow-y-auto tw-px-4 tw-py-2 tw-pt-8 tw-scrollbar-thin tw-scrollbar-track-iron-900 tw-scrollbar-thumb-iron-700">{t5}<PreviewLeaderboardListCase drop={previewDrop} onDropClick={onDropClick} /><PreviewLeaderboardGalleryCase drop={previewDrop} onDropClick={onDropClick} /></div>;
    $[4] = previewDrop;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== isSubmitting || $[7] !== onBackToEdit) {
    t7 = <SecondaryButton onClicked={onBackToEdit} disabled={isSubmitting}>Back to Edit</SecondaryButton>;
    $[6] = isSubmitting;
    $[7] = onBackToEdit;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== isSubmitting || $[10] !== onSubmit || $[11] !== submitLabel) {
    t8 = <PrimaryButton onClicked={onSubmit} disabled={false} loading={isSubmitting} padding="tw-px-6 tw-py-3">{submitLabel}</PrimaryButton>;
    $[9] = isSubmitting;
    $[10] = onSubmit;
    $[11] = submitLabel;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t7 || $[14] !== t8) {
    t9 = <div className="tw-mt-auto tw-flex tw-items-center tw-justify-between tw-border-t tw-border-iron-800 tw-px-4 tw-pt-6">{t7}{t8}</div>;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t6 || $[17] !== t9) {
    t10 = <motion.div initial={t2} animate={t3} exit={t4} className="tw-mx-auto tw-flex tw-h-full tw-max-w-6xl tw-flex-col tw-pb-8">{t6}{t9}</motion.div>;
    $[16] = t6;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
}
function _temp(_drop) {}